import { Navigate, useLocation } from 'react-router-dom';
import { useStore } from '../../store';
import type { JSX } from 'react';

export default function PrivateRoute({ children }: { children: JSX.Element }) {
  const isAuthenticated = useStore((s) => s.isAuthenticated);
  const location = useLocation();
  
  if (!isAuthenticated()) {
    // Only add redirect parameter if we're not already on login page
    if (location.pathname !== '/login') {
      const redirectUrl = encodeURIComponent(location.pathname + location.search);
      return <Navigate to={`/login?redirect=${redirectUrl}`} replace />;
    }
    return <Navigate to="/login" replace />;
  }
  
  return children;
}